import { ITheme } from "../../utils/theme";

export const buttonContainerStyle = {
  display: "flex",
  justifyContent: "center",
  mt: 5,
  mb: 5,
  gap: 6,
};

export const inputStyle = {
  minHeight: "5rem",
};

export const asteriskStyle = {
  color: (theme: ITheme) => theme.palette.red.A700,
};

export const messageStyle = (theme: ITheme) => ({
  color: theme.palette.red["850"],
  background: theme.palette.red["350"],
  padding: 4,
});

export const provideEmailBoxStyle = {
  pl: 2,
  pt: 2,
  pb: 2,
  mt: 2,
  mb: 2,
  ml: 2,
};

export const provideEmailTextStyle = {
  fontWeight: "bold",
  color: "primary.main",
  mb: 1,
};

export const emailReceivedBoxStyle = {
  ml: 2,
  mb: 2,
};

export const emailReceivedTextStyle = {
  fontWeight: "bold",
  color: "primary.main",
  pt: 2,
  pb: 1,
};
